import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[twTemplate]',
})
export class TemplateDirective {
  @Input('twTemplate') name?: string;

  constructor(public template: TemplateRef<any>) {}

  getType() {
    return this.name!;
  }
}
